import React from 'react';
import Preview from './component/RefundDetails';
import RefundOptions from './component/RefundOptions';
import FullRefund from './FullRefund';
import PartialRefund from './PartialRefund';
import { FULL_REFUND, } from './Constants';

const Workflow = (state) => {
  let globalState = {};

  if (state) {
    globalState.transactionId = state.payItTransactionId;
  }

  return [
    {
      component: stepFlow => (
        <Preview data={globalState} forward={stepFlow.forward} back={stepFlow.back}/>
      ),
    },
    {
      component: stepFlow => (
        <RefundOptions data={globalState} back={stepFlow.back} forward={stepFlow.forward}/>
      ),
    },
    {
      component: (stepFlow) => {
        const reset = () => {
          globalState = {};
          stepFlow.reset();
        };

        if (globalState.refundType === FULL_REFUND) {
          return <FullRefund data={globalState} back={stepFlow.back} reset={reset}/>;
        }
        return <PartialRefund data={globalState} back={stepFlow.back} reset={reset}/>;
      },
    },
  ];
};

export default Workflow;
